import clsx from 'clsx'
import Image, { ImageProps } from 'next/image'
import React, { useEffect, useState } from 'react'

import styles from './styles.module.scss'

export interface NextImageProps extends ImageProps {
  fallbackSrc?: string
  type?: 'cover' | 'contain'
  onClick?: () => void
  round?: boolean
}

const NextImage = ({
  src,
  fallbackSrc,
  type = 'cover',
  style = {},
  onClick,
  round,
  className,
  sizes,
  ...nextProps
}: NextImageProps) => {
  const [error, setError] = useState<boolean>(false)
  const classes = clsx(
    styles.container,
    styles[type],
    {
      [styles.onClick]: onClick,
      [styles.round]: round,
    },
    className,
  )

  useEffect(() => {
    setError(false)
  }, [src])

  return (
    <Image
      src={error && fallbackSrc ? fallbackSrc : src}
      role='img'
      fill
      sizes={sizes}
      className={classes}
      style={{ ...style, objectFit: type }}
      onClick={() => (onClick ? onClick() : {})}
      onError={() => setError(true)}
      {...nextProps}
    />
  )
}

export default NextImage
